import styled from 'styled-components';

export const DataIntegrationInfo = styled.div<{ fullScreen?: boolean }>`
  width: ${(props) => (props.fullScreen ? '100%' : '270px')};
  border-radius: ${(props) => (props.fullScreen ? '0px' : '5px')};
  background: ${(props) => props.theme.atlas.semantic.color.surface.inverse};
  color: ${(props) => props.theme.atlas.semantic.color.type.inverse};
  font-size: ${(props) => (props.fullScreen ? '14px' : '13px')};
  padding: 15px;
  display: flex;
  gap: 10px;
  line-height: 1.4;
  align-items: center;
`;
